import { memo, useEffect, useRef, useState } from "react";
import { XIcon } from "lucide-react";

import { ThreadList } from "@acme/ui/assistant-ui/thread-list";
import { Button } from "@acme/ui/button";
import { CodemodAILogo } from "@acme/ui/logo";
import { Popover, PopoverContent, PopoverTrigger } from "@acme/ui/popover";
import { ScrollArea } from "@acme/ui/scroll-area";

import { ChatHistoryIcon } from "~/app/_components/icons/chat-history";
import { useSession } from "~/utils/auth";
import { useCodemodAiPanel } from "../_hooks/use-codemod-ai-panel";

export const CodemodAIHeader = memo(({ onClose }: { onClose: () => void }) => {
  const { status } = useSession();
  const [thread] = useCodemodAiPanel();
  const [open, setOpen] = useState(false);
  const prevThread = useRef(thread);
  useEffect(() => {
    if (prevThread.current !== thread) {
      setOpen(false);
    }
    prevThread.current = thread;
  }, [thread]);

  return (
    <div className="border-b-border bg-background/80 sticky top-0 z-20 flex h-[47px] w-full flex-row items-center justify-between border-b py-1 pr-1 pl-2 shadow backdrop-blur-xl dark:shadow-xl">
      <h2 className="text-primary inline-flex flex-1 items-center gap-1 font-mono text-sm font-medium">
        <CodemodAILogo className="size-5" />
        Codemod AI
      </h2>
      {status === "authenticated" && (
        <div>
          <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
              <Button variant="ghost" size="icon" className="mr-1 size-7">
                <ChatHistoryIcon />
              </Button>
            </PopoverTrigger>
            <PopoverContent asChild className="p-0">
              <ScrollArea
                className="h-[calc(80vh-20px)]"
                containerClassName="px-3 py-4"
              >
                <ThreadList />
              </ScrollArea>
            </PopoverContent>
          </Popover>
        </div>
      )}
      <Button onClick={onClose} variant="ghost" size="icon" className="size-7">
        <XIcon />
      </Button>
    </div>
  );
});
